import { Controller } from 'stimulus';

// Hide Undecided toggle for the Attendance Status card. Hides the Undecided slice and its
// legend button and recalculates the remaining segment percentages over the visible
// categories only. Drill-down links are left untouched. The toggle state persists for the
// browser session (sessionStorage) so it survives navigating away and back.
const STORAGE_KEY = 'track-overview:hide-undecided';

export default class extends Controller {
  connect() {
    const input = this.element.querySelector('.switch__el');
    if (input && this.stored() === '1') {
      input.checked = true;
      this.render(true);
    }
  }

  toggle(event) {
    const hide = event.target.checked;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, hide ? '1' : '0');
    } catch (e) {
      // sessionStorage unavailable (private mode quota, etc.) — toggle still works in-page.
    }
    this.render(hide);
  }

  stored() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  render(hideUndecided) {
    const slices = Array.from(
      this.element.querySelectorAll('.status-bar__track .chart__slice--stackedbar'),
    );
    const visible = slices.filter((slice) => !(hideUndecided && this.isUndecided(slice)));
    const total = visible.reduce((sum, slice) => sum + this.value(slice), 0);

    slices.forEach((slice) => {
      if (hideUndecided && this.isUndecided(slice)) {
        slice.style.display = 'none';
        return;
      }
      slice.style.display = '';
      const pct = total > 0 ? (this.value(slice) / total) * 100 : 100 / visible.length;
      slice.style.width = `${pct}%`;
      const label = slice.querySelector('.chart__text');
      if (label) label.textContent = `${Math.round(pct)}%`;
    });

    this.element
      .querySelectorAll('.metric-legend .navbar__legend--row')
      .forEach((item) => {
        if (item.querySelector('.chart__dot--undecided')) {
          item.style.display = hideUndecided ? 'none' : '';
        }
      });
  }

  isUndecided(slice) {
    return slice.classList.contains('chart__slice--undecided');
  }

  value(slice) {
    return parseInt(slice.dataset.value, 10) || 0;
  }
}
